import { MessageCircle } from 'lucide-react'
import { PageTransition } from '@/components/ui/ux-enhancer'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'

export default function MessagePage() {
  const navigate = useNavigate()

  return (
    <PageTransition>
      <div className="max-w-lg mx-auto py-16">
        <Card className="text-center">
          <CardContent className="py-16 px-8 space-y-4">
            <div className="w-20 h-20 mx-auto bg-blue-50 rounded-full flex items-center justify-center">
              <MessageCircle className="w-10 h-10 text-blue-400" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">私信消息</h1>
            <p className="text-gray-500">
              私信功能正在开发中，敬请期待。
              <br />
              你可以先去首页逛逛，看看大家分享了什么新鲜事。
            </p>
            <div className="flex justify-center gap-3 pt-2">
              <Button onClick={() => navigate('/')}>回到首页</Button>
              <Button variant="outline" onClick={() => navigate('/publish')}>发布动态</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </PageTransition>
  )
}
